import {
  apiErrorMessageLocaleId,
  RepositoryError,
  RepositoryErrorDetails,
} from 'repositories/Error';
import { Failure, Result } from 'types';

export class ApplicationError extends Error {
  readonly originalMessage?: string;
  readonly errorDetails?: RepositoryErrorDetails;

  constructor(originalMessage?: string, errorDetails?: RepositoryErrorDetails) {
    super(originalMessage || 'ApplicationError');
    this.name = 'ApplicationError';
    this.originalMessage = originalMessage;
    this.errorDetails = errorDetails;
    // ES5 ターゲットへトランスパイルされても instanceof が機能するようにする
    Object.setPrototypeOf(this, ApplicationError.prototype);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApplicationError);
    }
  }

  localeId(message = ''): string {
    if (message === '') {
      return apiErrorMessageLocaleId(this.originalMessage);
    }
    return apiErrorMessageLocaleId(message);
  }

  static handleForRepositoryError<T>(
    error: unknown,
    handleStatusCodes: number[] = []
  ): Result<T, ApplicationError> {
    if (
      error instanceof RepositoryError &&
      (error.shouldNotRaiseError ||
        handleStatusCodes.length === 0 ||
        handleStatusCodes.includes(error.status))
    ) {
      return new Failure(new ApplicationError(error.apiMessage, error.details));
    }

    throw error;
  }
}

// 構成プロファイルインストールトークンが欠落している場合に投げるエラー。
// UI 側でトークン再作成フロー(方針B)へのリダイレクトが必要かどうかを instanceof で判別するために利用する。
export class ConfigurationProfileInstallTokenMissingError extends ApplicationError {
  constructor() {
    super('no configuration profile install token');
    this.name = 'ConfigurationProfileInstallTokenMissingError';
    // ES5 ターゲットへトランスパイルされても instanceof が機能するようにする
    Object.setPrototypeOf(
      this,
      ConfigurationProfileInstallTokenMissingError.prototype
    );
  }
}
